import { api } from '../core';
import { CASE_STATUS_TAG } from '../constants';
export type CaseStopPaginationProps = {
  caseId: string;
};
export type CasePaginationResponse = null;
const caseStopPaginationApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postCaseStopPagination: builder.query<CasePaginationResponse, CaseStopPaginationProps>({
      query: ({ caseId }: CaseStopPaginationProps) => ({
        url: 'case/cancel-pagination',
        method: 'POST',
        body: {
          case_id: caseId
        }
      }),
      async onQueryStarted({ caseId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(api.util.invalidateTags([{ type: CASE_STATUS_TAG, id: caseId }]));
        } catch (error) {
          if (error instanceof Error && error.name === 'AbortError') {
            console.log('Request was aborted');
          } else {
            console.error('Error in postCaseStopPagination in onQueryStarted:', error);
          }
        }
      },
      extraOptions: { maxRetries: 0 }
    })
  })
});
export const { useLazyPostCaseStopPaginationQuery } = caseStopPaginationApi;
